import { PlatformSlug } from 'constants/consts'
import { enabledOn, isFeatureAvailable } from 'platformConfig'

export const FULL_MINI_TESTS_CONFIG = enabledOn(
  PlatformSlug.DATBooster,
  PlatformSlug.OATBooster,
  PlatformSlug.DATCrusher
)

export const isFullMiniTestsAvailable = (slug?: PlatformSlug) => isFeatureAvailable(FULL_MINI_TESTS_CONFIG, slug)
